import { app, v } from "modular-openscriptjs";
import { IdGenerator, Pipeline, Requester } from "./fotastart";
import { routes as backendRoutes } from "./backendRoutes";
import { GoogleAnalytics } from "./analytics";
import {
	authenticated,
	can,
	formatThousand,
	redirect,
} from "./helpers";

// Import Classes from their new home
import { Notice, NoticeWrapper } from "./classes/Notice";
import { NavItem } from "./classes/NavItem";
import { Middleware } from "./classes/Middleware";
import { MainActionData } from "./classes/MainActionData";

// Import Contexts
import { gc, uc, dc, pc } from "./ojs.contexts";

// resolve the current page
app().value("currentPageResolver", () => null);

export const resolveCurrentPage = () => {
	return app("currentPageResolver")();	
}

/**
 * @param {() => HTMLElement} callback
 */
export const resolveCurrentPageUsing = (callback) => {
	app().value("currentPageResolver", callback);
}


export { Notice, NoticeWrapper, NavItem, Middleware, MainActionData, gc, uc, dc, pc };

// Network Requests
export const api = new Requester();

// ID generator
export const _UNIQUE_ID_ = new IdGenerator();

export const STRINGS = {
	SUCCESS: "success",
	ERROR: "error",
	INFO: "info",
	WARNING: "warning",
	DEFAULT: "default",
	CAPA_SYMBOL: "Ç",
};

/**
 * All pages
 * @enum {string}
 */
export const PAGES = {
	HOME: "Home",
	ORDERS: "Orders",
	ANALYTICS: "Analytics",
	BUSINESS_INFO: "Business Info",
	PROFILE: "Profile",
	EDIT_PROFILE: "Edit Profile",
	CHANGE_PASSWORD: "Change Password",
	FORGOT_PASSWORD: "Forgot Password",
	RESET_PASSWORD: "Reset Password",
	LOGIN: "Login",
	SETTINGS: "Settings",
	SEARCH: "Search",
	PAGE_404: "Not Found",
	OTP: "Identity",
	MANAGE_BUSINESS: "Manage Business",
	VIEW_PRODUCT: "View Product",
	AI_CREDITS: "AI Credits",
	PAYMENT: "Make Payment",
	DELIVERY_REQUESTS: "Delivery Requests",
};


export const ACTION_CALLBACKS = {};

const $e = app("$e");
const h = app("h");

/**
 * Default response pipeline
 */
export const rPipeline = new Pipeline();

export const analytics = new GoogleAnalytics();

gc.root = h.dom.querySelector("#app-root");

// Declare initial navItems

export let bottomNavItems = [
	NavItem.new({
		icon: () => h.i({ class: "bi bi-house" }),
		route: `/`,
		text: PAGES.HOME,
		appHook: 'home',
	}),

	NavItem.new({
		icon: () => h.i({ class: "bi bi-clipboard-data" }),
		route: `/orders`,
		text: PAGES.ORDERS,
		appHook: 'orders',
	}),
	
	NavItem.new({
		icon: () => h.i({ class: "bi bi-box-seam" }),
		route: `/current-inventory`,
		text: "Inventory",
		appHook: 'inventory',
	}),

	NavItem.new({
		icon: () => h.i({ class: "bi bi-graph-up" }),
		route: "/analytics",
		text: "Reports",
		appHook: 'analytics',
	}),

	NavItem.new({
		icon: () => h.i({ class: "bi bi-three-dots" }),
		onclick: `app("sendEvent")('${$e.ui.needs.offcanvas.nav}')`,
		text: "More",
		appHook: 'more-options',
	}),
];

export let offcanvasNavItems = [
	NavItem.new({
		text: PAGES.PROFILE,
		onclick: h.func("app('router').to", "user.view-profile", {
			user: "current",
		}),
		icon: () => h.i({ class: "bi bi-person" }),
		appHook: 'profile',
	}),

	NavItem.new({
		text: PAGES.AI_CREDITS,
		route: "/ai-credits",
		icon: () => h.i({ class: "bi bi-robot" }),
		appHook: 'ai-credits',
	}),

	NavItem.new({
		icon: () => h.i({ class: "bi bi-shop" }),
		route: `/manage`,
		text: PAGES.BUSINESS_INFO,
		appHook: 'business-info',
	}),

	NavItem.new({
		icon: () => h.i({ class: "bi bi-truck" }),
		route: "/current-delivery-requests",
		text: PAGES.DELIVERY_REQUESTS,
		appHook: 'delivery-requests',
	}),

	NavItem.new({
		icon: () => h.i({ class: "bi bi-briefcase" }),
		route: `/current-services`,
		text: "Services",
		appHook: 'services',
	}),

	NavItem.new({
		icon: () => h.i({ class: "bi bi-arrow-left-right" }),
		route: "/businesses/select",
		text: "Switch Business",
		appHook: 'switch-business',
	}),

	NavItem.new({
		icon: () => h.i({ class: "bi bi-gear" }),
		route: `/settings`,
		text: PAGES.SETTINGS,
		appHook: 'settings',
	}),

	NavItem.new({
		icon: () => h.i({ class: "bi bi-power" }),
		onclick: `app("sendEvent")('${$e.user.needs.logout}')`,
		text: "Logout",
		appHook: 'logout',
	}),
];

export let sideNavItems = [
	NavItem.new({
		icon: () => h.i({ class: "bi bi-house-door" }),
		route: `/`,
		text: PAGES.HOME,
		appHook: 'home',
	}),

	NavItem.new({
		icon: () => h.i({ class: "bi bi-clipboard-data" }),
		route: `/orders`,
		text: PAGES.ORDERS,
		appHook: 'orders',
	}),

	
	NavItem.new({
		icon: () => h.i({ class: "bi bi-box-seam" }),
		route: `/current-inventory`,
		text: "Inventory",
		appHook: 'inventory',
	}),
	
	NavItem.new({
		icon: () => h.i({ class: "bi bi-briefcase" }),
		route: `/current-services`,
		text: "Services",
		appHook: 'services',
	}),
	
	NavItem.new({
		icon: () => h.i({ class: "bi bi-graph-up" }),
		route: "/analytics",
		text: PAGES.ANALYTICS,
		appHook: 'analytics',
	}),

	NavItem.new({
		icon: () => h.i({ class: "bi bi-truck" }),
		route: "/current-delivery-requests",
		text: PAGES.DELIVERY_REQUESTS,
		appHook: 'delivery-requests',
	}),


	NavItem.new({
		icon: () => h.i({ class: "bi bi-shop" }),
		route: `/manage`,
		text: PAGES.BUSINESS_INFO,
		appHook: 'business-info',
	}),

	NavItem.new({
		text: PAGES.PROFILE,
		onclick: h.func(`app("router").to`, "user.view-profile", {
			user: "current",
		}),
		icon: () => h.i({ class: "bi bi-person" }),
		appHook: 'profile',
	}),

	NavItem.new({
		icon: () => h.i({ class: "bi bi-arrow-left-right" }),
		route: "/businesses/select",
		text: "Switch Business",
		appHook: 'switch-business',
	}),

	NavItem.new({
		icon: () => h.i({ class: "bi bi-gear" }),
		route: `/settings`,
		text: PAGES.SETTINGS,
		appHook: 'settings',
	}),

	NavItem.new({
		icon: () => h.i({ class: "bi bi-power" }),
		onclick: `app("sendEvent")('${$e.user.needs.logout}')`,
		text: "Logout",
		appHook: 'logout',
	}),
];

export const routes = backendRoutes;